/**
 * view.js
 *
 * Este script é carregado no frontend.
 * Ele faz com que o ícone SVG personalizado seja clicável,
 * acionando a abertura/fechamento do bloco <details> adjacente.
 */
document.addEventListener('DOMContentLoaded', function () {
    // 1. Encontra todos os wrappers do nosso bloco na página.
    const wrappers = document.querySelectorAll('.details-custom-marker-wrapper');

    // 2. Itera sobre cada bloco encontrado.
    wrappers.forEach(wrapper => {
        // 3. Encontra o ícone e o elemento <details> dentro do wrapper atual.
        const iconWrapper = wrapper.querySelector('.custom-svg-icon-wrapper');
        const detailsElement = wrapper.querySelector('details');

        // 4. Garante que ambos foram encontrados antes de prosseguir.
        if (iconWrapper && detailsElement) {
            const summaryElement = detailsElement.querySelector('summary');

            if (summaryElement) {
                // 5. Adiciona um "ouvinte" de clique no ícone.
                iconWrapper.addEventListener('click', function () {
                    // 6. Quando o ícone é clicado, ele simula um clique no <summary>.
                    // Esta é a forma mais limpa e segura de alternar o estado do <details>.
                    summaryElement.click();
                });
            }
        }
    });
});